import { Button, ModalWindow } from "@tblabs/truffle";
import { ShellCommandsStorage } from "./ShellCommandsStorage";
import { Terminal } from "./Terminal";
import { FileEditWindow } from "./FileEditWindow";
import { Device } from "../../Services/Device";


export class TerminalWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super("💻 " + device.Id + " Terminal");
        this.WidthPercent(80);

        if (!device._server.IsConnected)
        {
            alert("Panel is not connected to the server. Please refresh the page.");
            return;
        }

        const commandsStorage = new ShellCommandsStorage();

        this.AddContent(
            new Terminal(device, commandsStorage),
        );

        const fileEditWindow = new FileEditWindow(device).HideOnClose();

        this.AddToFooter(
            new Button("📜 File editor", () => fileEditWindow.ShowWindow())
                .Class("uk-button uk-button-primary")
                .FloatLeft(),
            new Button("Close", () => this.CloseWindow())
                .Class("uk-button uk-button-default")
                .FloatRight(),
        )

        this.OpenWindow();
    }
}
